import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getConfig } from 'tw-oi-core'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { trackBrowseTopicClick, trackBrowseFolderClick } from 'tw-oi-core/services/analytics'
import { recalculateTopicsHeightForIOS } from '../extras/utils'

import { DEFAULT_PUBLICATION_TYPE, ROUTE } from '../config'

import { connect } from 'react-redux'

import ContentList from '../components/ContentList'
import BrowseGuideLayout from '../components/BrowseGuideLayout'
import Loader from '../components/Loader'

import '../styles/Topics.scss'
import {
  getRootFolderResourceKey,
  getParentFolder,
  isRootFolder,
  isFolder,
  isCollapsedFolder,
  isDitaTopic,
} from '../extras/utils'

class BrowseDita extends Component {
  static propTypes = {
    fetching: PropTypes.bool,
    publications: ImmutablePropTypes.list,
    topics: ImmutablePropTypes.list,
    folders: ImmutablePropTypes.list,
    foldersIndex: ImmutablePropTypes.map,
    match: PropTypes.object.isRequired,
    baseRoute: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    userMedia: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
  }

  constructor(props) {
    super(props)

    const { BROWSE_ROOT_KEY } = getConfig()
    const { foldersIndex, topics, baseRoute, match, history, publications } = props
    const rootFolderResourceKey = getRootFolderResourceKey(
      publications,
      DEFAULT_PUBLICATION_TYPE,
      foldersIndex,
      BROWSE_ROOT_KEY
    )
    let folderId = match.params.folderId || rootFolderResourceKey

    let activeFolder = foldersIndex && foldersIndex.size ? foldersIndex.get(folderId) : null
    if (!activeFolder || !isFolder(activeFolder.toJS())) {
      let possibleTopic = topics.find(item => item.get('resourceKey') === match.params.folderId)
      if (
        (activeFolder && isCollapsedFolder(activeFolder.toJS())) ||
        (possibleTopic && isDitaTopic(possibleTopic.toJS()))
      ) {
        const url = `${baseRoute}${ROUTE.BROWSE}${ROUTE.TOPIC}/${match.params.folderId}`
        history.replace(url)
        activeFolder = null
      }
    }
    const isActiveFolderRoot = isRootFolder(activeFolder, rootFolderResourceKey)
    this.state = {
      activeFolder,
      rootFolderResourceKey,
      isActiveFolderRoot,
      parentFolder: activeFolder && !isActiveFolderRoot ? getParentFolder(activeFolder, foldersIndex) : null,
    }
  }

  componentDidUpdate(prevProps) {
    const { rootFolderResourceKey } = this.state

    if (prevProps.match.params.folderId !== this.props.match.params.folderId) {
      const { foldersIndex, match } = this.props

      const folderId = match.params.folderId || rootFolderResourceKey
      const activeFolder = foldersIndex && foldersIndex.size ? foldersIndex.get(folderId) : null
      const isActiveFolderRoot = isRootFolder(activeFolder, rootFolderResourceKey)
      this.setState({
        activeFolder,
        isActiveFolderRoot,
        parentFolder: activeFolder && !isActiveFolderRoot ? getParentFolder(activeFolder, foldersIndex) : null,
      })

      recalculateTopicsHeightForIOS()
    }
  }

  trackItem(item) {
    switch (item.type) {
      case 'folder':
        isCollapsedFolder(item) ? trackBrowseTopicClick(item.title) : trackBrowseFolderClick(item.title)
        break
      case 'topic':
        trackBrowseTopicClick(item.title)
        break
      default:
    }
  }

  render() {
    const { baseRoute, fetching, match, userMedia } = this.props
    const { activeFolder } = this.state
    const contents = activeFolder ? activeFolder.get('contents') : null

    if (!activeFolder) {
      return (
        <Loader type='status' className='inverse'>
          Folder not found
        </Loader>
      )
    }

    return (
      <BrowseGuideLayout match={match} baseRoute={baseRoute}>
        {fetching ? (
          <Loader className='inverse' />
        ) : (
          <ContentList
            variant='browse-guide'
            isDesktop={userMedia.isDesktop}
            topics={Object.values(contents.toJS())}
            baseRoute={baseRoute + ROUTE.BROWSE}
            onClick={topic => this.trackItem(topic)}
          />
        )}
      </BrowseGuideLayout>
    )
  }
}

function mapStateToProps({ contents, vehicle, user }) {
  const { topics, folders, foldersIndex, publications, fetching, currentAsset, fetchingAsset, currentFolder } = contents
  const { currentYear, currentModel, currentBrand } = vehicle
  const { media: userMedia } = user

  return {
    topics,
    folders,
    foldersIndex,
    publications,
    fetching,
    currentAsset,
    fetchingAsset,
    currentYear,
    currentModel,
    currentBrand,
    currentFolder,
    userMedia,
  }
}

export default connect(mapStateToProps)(BrowseDita)
